enum CatalogQueryIndex {
  Default = 'ng-products-master',
  US = 'ng-products-slave-us',
  PriceAscending = 'ng-products-slave-price-asc',
  PriceDescending = 'ng-products-slave-price-desc',
  Recent = 'ng-products-slave-recent',
}

export default CatalogQueryIndex;
